export const useConfig = () => {
  return {
    amveraRegion: process.env.NEXT_PUBLIC_AMVERA_REGION,
    domainTcpSuffix: process.env.DOMAIN_TCP_SUFFIX,
    defaultDomainSuffix: process.env.DEFAULT_DOMAIN_SUFFIX,
    externalIp: process.env.AMVERA_EXTERNAL_IP,
    profileLink: process.env.AMVERA_PROFILE,
  };
};
